import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/redesign-temp/girl-s6-p2.svg")